import React from 'react';

import { Box, Collapse } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormSelect } from 'common/components/form/bootstrap';
import ReactHookFormRoofSelect from 'common/components/segment/ReactHookFormRoofSelect';

import resource_ARCK_GRANJA_LOSA from 'resources/SystemTypes/GranjaLosaDeAluminio.JPG';
import resource_ARCK_LASTRADA_DOBLE from 'resources/SystemTypes/LastradaDobleInclinacion.JPG';
import resource_ARCK_LASTRADA_SENCILLA from 'resources/SystemTypes/LastradaUnaInclinacion.JPG';
import resource_ARCK_LOSA_CONVENCIONAL from 'resources/SystemTypes/LosaConvencional.JPG';
import resource_ARCK_CUBIERTA_GRAFADA from 'resources/SystemTypes/StandingSeamGclamp.JPG';
import resource_ARCK_TEJA_BARRO from 'resources/SystemTypes/TejaDeBarro.JPG';
import resource_ARCK_TRAPEZOIDAL from 'resources/SystemTypes/Trapezoidal.JPG';
import resource_ARCK_TRAPEZOIDAL_RAILLESS from 'resources/SystemTypes/TrapezoidalRailles.png';
import resource_ARCK_GCLAMP_RAILLESS from 'resources/SystemTypes/TrapezoidalTipoSandwichRailLess.png';

const RoofAndSystemTypeSelects = ({
    control,
    disabled = false,
    onChangeSystem,
    onChangeTypeApplication,
    roofTypesOptions,
    systemTypesOptions,
    systemUid,
    typeApplication,
}) => {
    const { t } = useTranslation();

    const systemTypeTooltips = {
        'ARCK-GRANJA LOSA': resource_ARCK_GRANJA_LOSA,
        'ARCK-LASTRADA DOBLE': resource_ARCK_LASTRADA_DOBLE,
        'ARCK-LASTRADA SENCILLA': resource_ARCK_LASTRADA_SENCILLA,
        'ARCK-LOSA CONVENCIONAL': resource_ARCK_LOSA_CONVENCIONAL,
        'ARCK-CUBIERTA GRAFADA': resource_ARCK_CUBIERTA_GRAFADA,
        'ARCK-GCLAMP RAILLESS': resource_ARCK_GCLAMP_RAILLESS,
        'ARCK-TEJA BARRO': resource_ARCK_TEJA_BARRO,
        'ARCK-TRAPEZOIDAL': resource_ARCK_TRAPEZOIDAL,
        'ARCK-TRAPEZOIDAL RAILLESS': resource_ARCK_TRAPEZOIDAL_RAILLESS,
    };

    const tooltipImage = systemTypeTooltips[systemUid];

    const open = !isEmpty(tooltipImage);

    return (
        <>
            <ReactHookFormRoofSelect
                control={control}
                disabled={disabled}
                label={t('Roof type')}
                name="type_application"
                onChange={onChangeTypeApplication}
                options={roofTypesOptions}
            />

            <Box sx={{ flexGrow: 1 }}>
                <ReactHookFormSelect
                    control={control}
                    disabled={disabled || isEmpty(typeApplication)}
                    label={t('System type')}
                    name="system"
                    onChange={onChangeSystem}
                    options={systemTypesOptions}
                />
            </Box>

            <Collapse in={open}>
                <Box sx={{ mt: 1, mb: 1, height: '250px' }}>
                    <img
                        alt=""
                        src={tooltipImage}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                        }}
                    />
                </Box>
            </Collapse>
        </>
    );
};

RoofAndSystemTypeSelects.propTypes = {
    control: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    onChangeSystem: PropTypes.func.isRequired,
    onChangeTypeApplication: PropTypes.func.isRequired,
    roofTypesOptions: PropTypes.array.isRequired,
    systemTypesOptions: PropTypes.array.isRequired,
    systemUid: PropTypes.string,
    typeApplication: PropTypes.string,
};

export default RoofAndSystemTypeSelects;
